import { useEffect, useRef } from "react";
import { observeHomepageLeagueLimit, useHomepageExperiment } from "./homepageExperiment";

/** Observe depleted guest allowance and mode changes identically in both arms. */
export function useGuestLeagueLimitTracking(isGuest: boolean, leagueGames: number, leaguePlay: boolean) {
  const { ready, assignment } = useHomepageExperiment();
  const previousMode = useRef(leaguePlay);
  useEffect(() => {
    const switched = previousMode.current && !leaguePlay;
    previousMode.current = leaguePlay;
    if (!isGuest || !(leagueGames <= 0) || !ready || !assignment) return;
    const record = () => {
      if (document.visibilityState !== "visible") return;
      void observeHomepageLeagueLimit("league_limit_reached");
      if (switched) void observeHomepageLeagueLimit("league_limit_practice");
    };
    record();
    document.addEventListener("visibilitychange", record);
    return () => document.removeEventListener("visibilitychange", record);
  }, [isGuest, leagueGames, leaguePlay, ready, assignment?.key]);
}
